import type { Profile } from "../../../core/backend/clients/backendClient";

export class ClinicDoctorModel {
  id: number = 0;
  favouriteId: number = 0;

  clinicId: number = 0;
  clinicName: string = "";
  clinicAddress?: string;
  clinicProfessionName?: string;
  clinicImagePath?: string;

  doctorId: number = 0;
  doctorName: string = "";
  doctorPhoneRequired: boolean = false;
  doctorImagePath?: string;

  profiles: Profile[] = [];

  isLoading: boolean = false;

  constructor(init?: Partial<ClinicDoctorModel>) {
    if (init) Object.assign(this, init);
  }
}
